module.exports = __webpack_public_path__ + "img/fig7.4.058e748e.png";